<template>
  <b-row>
    <b-col cols="12" class="mb-5">
      <PageTitle title="Lista de pedidos" />
    </b-col>
    <b-col cols="12" class="mb-4">
      <label for="">Lojistas</label>
      <SelectShopkeeperWithApp
        v-model="fields.shopkeepersIds"
        propValueName="userId"
        @update:value="searchTimeOut"
      />
    </b-col>
    <b-col cols="6" class="mb-4">
      <input
        type="text"
        v-model.trim="fields.clientName"
        class="form-control"
        placeholder="Nome do cliente"
        @input="searchTimeOut"
      />
    </b-col>
    <b-col cols="6" class="mb-4">
      <input
        min="0"
        type="number"
        v-model.number="fields.orderNumber"
        @input="
          () => {
            searchTimeOut();
            handleOrderNumber();
          }
        "
        class="form-control"
        placeholder="Número do pedido"
      />
    </b-col>
    <b-col cols="12" class="mb-4">
      <PeriodsFilters
        ref="periodsFilters"
        :setDatesAutomatic="false"
        :startDate.sync="fields.startDate"
        :endDate.sync="fields.endDate"
        @update:startDate="searchTimeOut"
        @update:endDate="searchTimeOut"
      />
    </b-col>
    <b-col cols="12">
      <label class="font-weight-bold">Status do pedido</label>
      <div>
        <h4>
          <b-badge
            :variant="
              fields.status.includes(ORDER_STATUS.SEPARATING_ORDER)
                ? 'primary'
                : 'light'
            "
            class="pointer"
            @click="addStatus(ORDER_STATUS.SEPARATING_ORDER)"
          >
            {{ getOrderStatusText(ORDER_STATUS.SEPARATING_ORDER) }}
          </b-badge>
          <b-badge
            :variant="
              fields.status.includes(ORDER_STATUS.WAITING_PAYMENT)
                ? 'primary'
                : 'light'
            "
            class="mx-3 pointer"
            @click="addStatus(ORDER_STATUS.WAITING_PAYMENT)"
          >
            {{ getOrderStatusText(ORDER_STATUS.WAITING_PAYMENT) }}
          </b-badge>
          <b-badge
            :variant="
              fields.status.includes(ORDER_STATUS.SENT) ? 'primary' : 'light'
            "
            class="mx-3 pointer"
            @click="addStatus(ORDER_STATUS.SENT)"
          >
            {{ getOrderStatusText(ORDER_STATUS.SENT) }}
          </b-badge>
          <b-badge
            :variant="
              fields.status.includes(ORDER_STATUS.DELIVERED)
                ? 'primary'
                : 'light'
            "
            class="mx-3 pointer"
            @click="addStatus(ORDER_STATUS.DELIVERED)"
          >
            {{ getOrderStatusText(ORDER_STATUS.DELIVERED) }}
          </b-badge>
          <b-badge
            :variant="
              fields.status.includes(ORDER_STATUS.CANCELED)
                ? 'primary'
                : 'light'
            "
            class="mx-3 pointer"
            @click="addStatus(ORDER_STATUS.CANCELED)"
          >
            {{ getOrderStatusText(ORDER_STATUS.CANCELED) }}
          </b-badge>
          <b-badge
            :variant="
              fields.status.includes(ORDER_STATUS.READY_FOR_PICKUP)
                ? 'primary'
                : 'light'
            "
            class="mx-3 pointer"
            @click="addStatus(ORDER_STATUS.READY_FOR_PICKUP)"
          >
            Pronto para retirada
          </b-badge>
          <b-badge
            :variant="
              fields.status.includes(ORDER_STATUS.EXPIRED)
                ? 'primary'
                : 'light'
            "
            class="mx-3 pointer"
            @click="addStatus(ORDER_STATUS.EXPIRED)"
          >
            Expirado
          </b-badge>
          <b-badge
            :variant="
              fields.status.length === Object.keys(ORDER_STATUS).length
                ? 'primary'
                : 'light'
            "
            class="mx-3 pointer"
            @click="addAllStatus()"
          >
            Todos
          </b-badge>
        </h4>
      </div>
    </b-col>
    <b-col cols="12" class="mt-4">
      <b-button variant="success" @click="list()">
        <i class="fas fa-search mr-2"></i>
        Pesquisar
      </b-button>
    </b-col>
    <b-col
      cols="12"
      class="mt-5 mb-2 d-flex align-items-center justify-content-between"
    >
      <order-status
        :endDate="fields.endDate"
        :startDate="fields.startDate"
        :shopkeepersIds="fields.shopkeepersIds"
      />
    </b-col>
    <b-col class="mt-5 mb-2 d-flex align-items-center justify-content-between">
      <h3 class="title font-weight-bold">
        {{ pagination.total }} pedidos encontrados
      </h3>
      <b-button
        v-if="!generatingSpreadsheet"
        pill
        variant="success"
        @click="generateSpreadsheet()"
      >
        <i class="fas fa-file-download mr-2"></i>
        Baixar planilha
      </b-button>
      <b-spinner v-else variant="success" label="Spinning"></b-spinner>
    </b-col>
    <b-col cols="12">
      <b-table
        striped
        responsive
        hover
        show-empty
        empty-text="Sem produtos encontrados"
        :fields="table.headers"
        :items="table.records"
        :busy="loading"
      >
        <template #table-busy>
          <div class="text-center my-2">
            <b-spinner class="align-middle mr-2"></b-spinner>
            <strong>Carregando...</strong>
          </div>
        </template>
        <template #cell(status)="data">
          {{ getOrderStatusText(data.item.status) }}
        </template>
        <template #cell(totalValue)="data">
          {{ formatNumber(data.item.totalValue) }}
        </template>
        <template #cell(paymentType)="data">
          {{ getPaymentTypeText(data.item.paymentType) }}
        </template>

        <template #cell(ShopkeeperName)="data">
          {{ getNameShopekeeper(data.item.construp_user_id, true) }}
        </template>

        <template #cell(actions)="data">
          <b-col style="width: 120px" class="pr-0">
            <b-button
              variant="outline-dark"
              size="sm"
              title="Detalhes do pedido"
              class="mr-2 mb-2"
              v-if="!data.item.editing"
              @click="$refs.orderDetails.toggleOpen(
                { 
                  orderId: data.item.id, 
                  uuid: data.item.uuid, 
                  data: getNameShopekeeper(data.item.construp_user_id, false),
                  dataModal: data.item
                })"
            >
              <i class="fas fa-eye"></i>
            </b-button>
          </b-col>
        </template>
      </b-table>
    </b-col>
    <b-col cols="12" class="d-flex align-items-center justify-content-center">
      <b-pagination
        v-model="pagination.currentPage"
        :total-rows="pagination.total"
        :per-page="pagination.itemsPerPage"
        :disabled="loading"
      ></b-pagination>
    </b-col>

    <OrderDetails ref="orderDetails" :shopkeepersIds="fields.shopkeepersIds" />
  </b-row>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import * as XLSX from 'xlsx';

import { formatNumber } from '@/utils';

import ORDER_STATUS from 'Enums/Order/Status.js';

import PageTitle from 'Components/PageTitle.vue';
import makeToast from 'Mixins/makeToast';
import PeriodsFilters from 'Components/Inputs/PeriodsFilters.vue';
import OrderDetails from 'Components/Order/OrderDetails.vue';
import SelectShopkeeperWithApp from 'Components/Inputs/SelectShopkeeperWithApp.vue';
import OrderStatus from 'Components/Order/OrderStatus.vue';

export default {
  name: 'OrdersAppList',
  mixins: [makeToast],
  components: {
    PageTitle,
    PeriodsFilters,
    OrderDetails,
    SelectShopkeeperWithApp,
    OrderStatus,
  },
  data() {
    return {
      ORDER_STATUS,
      generatingSpreadsheet: false,
      loading: false,
      showConfirmationPopover: false,
      currentOrderBeingEditedId: 0,
      fields: {
        shopkeepersIds: [],
        clientName: '',
        orderNumber: null,
        startDate: '',
        endDate: '',
        status: [],
        selectedOrders: {},
      },
      pagination: {
        currentPage: 1,
        itemsPerPage: 1,
        total: 0,
      },
      table: {
        headers: [
          {
            key: 'index',
            thClass: 'd-none',
            tdClass: 'd-none',
          },
          // {
          //   key: 'id',
          //   label: 'id tabela',
          //   sortable: true,
          // },
          {
            key: 'uuid',
            label: 'Pedido',
            sortable: true,
          },
          {
            key: 'date',
            label: 'Data',
            sortable: true,
          },
          {
            key: 'status',
            label: 'Status Pagamento',
            sortable: true,
          },
          {
            key: 'ShopkeeperName',
            label: 'Lojista',
            sortable: true,
          },
          {
            key: 'clientName',
            label: 'Cliente',
            sortable: true,
          },
          {
            key: 'purchaseOrigin',
            label: 'Origem',
          },
          // Cartão colocar qtas vezes
          {
            key: 'paymentType',
            label: 'Forma de Pgto',
            sortable: true,
          },
          // {
          //   key: 'shippingType',
          //   label: 'Tipo de envio',
          //   sortable: true,
          // },
          {
            key: 'totalValue',
            label: 'Valor total',
            sortable: true,
          },
          // Frete ou Retirada
          {
            key: '',
            label: 'Status Entrega',
            sortable: true,
          },
          // Status Pedido
          {
            key: '',
            label: 'Status Pedidos',
            sortable: true,
          },
          {
            key: 'actions',
            label: 'Ações',
            sortable: false,
          },
        ],
        records: [],
      },
      timer: null,
      shopkeepersData: [],
    };
  },
  computed: {
    ...mapState(['dadosUsuario']),
    orderStatusItems() {
      const items = [];

      Object.keys(ORDER_STATUS).forEach((key) => {
        items.push({
          id: ORDER_STATUS[key],
          name: this.getOrderStatusText(ORDER_STATUS[key]),
        });
      });

      return items;
    },
  },
  watch: {
    'pagination.currentPage': function () {
      this.list();
    },
  },
  mounted() {
    this.list();
  },
  methods: {
    formatNumber,
    ...mapActions('admin', ['getOrdersSummary']),
    searchTimeOut() {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }

      this.timer = setTimeout(() => {
        this.list();
      }, 800);
    },
    list() {
      this.loading = true;

      const {
        shopkeepersIds,
        clientName,
        orderNumber,
        startDate,
        endDate,
        status,
      } = this.fields;

      this.getOrdersSummary({
        currentPage: this.pagination.currentPage,
        shopkeepersIds,
        clientName,
        orderNumber,
        startDate,
        endDate,
        status,
      })
        .then((response) => {
          const { perPage, total, data } = response.data.data || {};

          this.pagination.itemsPerPage = perPage || 50;
          this.pagination.total = total || 0;

          this.$set(this.table, 'records', data || []);
          this.getDataShopkeeper();
        })
        .catch(() => {
          this.makeToast(
            'Erro',
            'Houve um erro ao trazer os pedidos',
            'danger'
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    generateSpreadsheet() {
      if (!this.table.records || !this.table.records.length) return;

      this.generatingSpreadsheet = true;

      const clientsData = XLSX.utils.json_to_sheet(
        this.convertColumnsNames(this.table.records)
      );

      const excelFile = XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(excelFile, clientsData, 'Lista de clientes');

      const currentDate = new Date().toLocaleDateString('pt-BR');
      const fileName = `Lista de pedidos - ${currentDate}`;

      setTimeout(() => {
        this.generatingSpreadsheet = false;
      }, 1000);

      XLSX.writeFile(excelFile, `${fileName}.xlsx`);
    },
    /**
     * @param {Array} records
     * @returns {Array}
     */
    convertColumnsNames(records) {
      if (!records || !records.length) return [];

      const returnArray = [];

      records.forEach((record) => {
        const cell = {};

        Object.keys(record).forEach((key) => {
          const tableColumn = this.table.headers.find((x) => x.key === key);

          if (key === 'status') {
            cell[`${tableColumn.label}`] = this.getOrderStatusText(record[key]);
            return;
          }

          if (key === 'paymentType') {
            cell[`${tableColumn.label}`] = this.getPaymentTypeText(record[key]);
            return;
          }

          if (key === 'totalValue') {
            cell[`${tableColumn.label}`] = formatNumber(record[key]);
            return;
          }

          cell[`${tableColumn.label}`] = record[key];
        });

        returnArray.push(cell);
      });

      return returnArray;
    },
    handleOrderNumber() {
      if (!this.fields.orderNumber) return;

      this.$set(this.fields, 'orderNumber', Math.abs(this.fields.orderNumber));
    },
    addStatus(userType) {
      if (this.fields.status.includes(userType)) {
        const index = this.fields.status.indexOf(userType);
        this.fields.status.splice(index, 1);
        this.list();
        return;
      }

      this.fields.status.push(userType);
      this.list();
    },
    addAllStatus() {
      Object.values(ORDER_STATUS).forEach((value) => {
        if (this.fields.status.includes(value)) return;

        this.fields.status.push(value);
      });

      this.list();
    },
    getPaymentTypeText(type) {
      const texts = {
        credit_card: 'Cartão de crédito',
        pix: 'Pix',
        all: 'Boleto',
        wallet: 'Carteira',
        shopkeeper: 'Recebimento com a loja'
      };

      return texts[type] || 'N/A';
    },
    getOrderStatusText(status) {
      const texts = {
        [ORDER_STATUS.WAITING_PAYMENT]: 'Aguardando pagamento',
        [ORDER_STATUS.SEPARATING_ORDER]: 'Separando pedido',
        [ORDER_STATUS.SENT]: 'Saiu para entrega',
        [ORDER_STATUS.DELIVERED]: 'Entregue',
        [ORDER_STATUS.CANCELED]: 'Cancelado',
        [ORDER_STATUS.READY_FOR_PICKUP]: 'Pronto para retirada',
        [ORDER_STATUS.EXPIRED]: 'Expirado',
      };

      return texts[status] || 'N/A';
    },

    getDataShopkeeper(){
      const data = {
        shopkeepers:[]
      }; 

      this.table.records.forEach(element => {
        if(!data.shopkeepers.includes(element.construp_user_id)){
          data.shopkeepers.push(element.construp_user_id);
        }
      });

      this.loading = true;
      this.$store.dispatch('admin/showDataShopkeeperApp', data)
      .then((response) => {
        this.shopkeepersData = response.data;
      })
      .catch(() => {})
      .finally(() => {
        this.loading = false;
      })
    },
    getNameShopekeeper(id, name = false){
      const data = this.shopkeepersData.find(n => n.userId == id);
      if(name){
        return data.nome_fantasia ? data.nome_fantasia : data.razao_social;
      }
      return data
    }
  },
};
</script>
